export default __webpack_public_path__ + "static/media/Edge-Logo.0543128b.svg";